import { render, staticRenderFns } from "./ReleaseInformation.vue?vue&type=template&id=60f0b652&scoped=true&"
import script from "./ReleaseInformation.vue?vue&type=script&lang=js&"
export * from "./ReleaseInformation.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseInformation.vue?vue&type=style&index=0&id=60f0b652&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f0b652",
  null
  
)

export default component.exports